module.exports = __webpack_public_path__ + "static/media/d4.e905f0fd.jpg";